const sectionBannerSliderCss = `
[data-type='section-banner-slider'] [data-attribute='card-container'] {
  padding: 40px 0;
}

[data-type='section-banner-slider'] * {
  box-sizing: border-box;
}

[data-type='section-banner-slider'] .wrap-card .swiper-pagination .swiper-pagination-bullet {
  opacity: 1;
  background-color: var(--pagination-inactive-color, #cccccc);
}

[data-type='section-banner-slider'] .wrap-card .swiper-pagination .swiper-pagination-bullet-active {
  background-color: var(--pagination-active-color, #000000) !important;
}

[data-type='section-banner-slider'] .wrap-card .swiper-slide .wrap-ct {
  position: relative;
}

[data-type='section-banner-slider'] .wrap-card .swiper-slide .wrap-ct .wrap-img img {
  display: block;
  width: 100%;
  height: auto;
}

[data-type='section-banner-slider'] .wrap-card .swiper-slide .wrap-ct .wrap-text-btn {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 40px;
  padding: 0 20px;
  z-index: 5;
  color: var(--text-color, #fff);
}

[data-type='section-banner-slider'] .wrap-card .swiper-slide .wrap-ct .wrap-text-btn .wrap-text {
  text-align: center;
  margin-bottom: 16px !important;
}

[data-type='section-banner-slider'] .wrap-card .swiper-slide .wrap-ct .wrap-text-btn .wrap-btn {
  text-align: center;
}

[data-type='section-banner-slider'] .wrap-card .swiper-slide .wrap-ct .wrap-text-btn .wrap-btn .btn-slide {
  display: inline-block;
  width: fit-content;
  padding: 10px 20px;
  background-color: var(--button-background-color, #000);
  color: var(--button-text-color, #fff);
  border-radius: 5px;
  text-decoration: none;
}

[data-type='section-banner-slider'] .wrap-card .swiper-slide .wrap-ct .slide-overlay {
  inset: 0;
  position: absolute;
  z-index: 4;
}

@container (max-width: 768px) {
  [data-type='section-banner-slider'] [data-attribute='card-container'] {
    padding: 16px 0;
  }
}
`;

export default sectionBannerSliderCss;
